module.exports = __webpack_public_path__ + "02_short_yellow.ba8c10f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_short_yellow.png
// module id = IgdI
// module chunks = 0